<template>
    <div>
        <rkm-form
            ref="Form"
            show-legend
        >
            <rkm-row>

                <rkm-col cols="6">
                    <rkm-form-date-picker
                        range
                        :range-inline="false"
                        start-label="Período de"
                        end-label="Até"
                        v-model="model.periodo"
                        :max-date="data.form.dataAtual"
                        :start-validations="validations.periodo.start"
                        :end-validations="validations.periodo.end"
                    />
                </rkm-col>

                <rkm-col cols="6" >
                    <rkm-form-input-autocomplete
                        :searchFields="localPaciente.autocompleteFieldsPaciente.paciente"
                        :repository="repositories.paciente"
                        v-model="paciente"
                        :text-field="(item) =>  item.cidadao.cns ? `${this.formatCns(item.cidadao.cns)} - ${item.cidadao.nome}` : item.cidadao.nome"
                        label="Paciente"
                        uppercase
                        @select="setListagem()"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row class="flex-nowrap">

                <rkm-col cols="3">
                    <rkm-form-date-picker
                        label="Data de nascimento"
                        v-model="model.dataNascimento"
                        :max-date="data.form.dataAtual"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        label="Prontuário"
                        v-model="model.prontuario"
                        number
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-select
                        :options="agendamentoExame"
                        label="Exame"
                        show-default-option
                        text-field="nome"
                        v-model="model.exameId"
                        value-field="id"
                        @change="setListagem()"
                    />
                </rkm-col>

                <rkm-col class="flex-grow-1">
                    <rkm-form-input
                        label="Número do agendamento"
                        v-model="model.agendamentoNumero"
                        number
                    />
                </rkm-col>

                <rkm-col cols="auto">
                    <rkm-button
                        :label="false"
                        color="primary"
                        @click="$refs.Form.validate(search)"
                    >
                        Buscar
                    </rkm-button>

                    <rkm-button
                        :label="false"
                        @click="resetForm()"
                    >
                        Limpar
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-table
            v-if="itemsNotSave"
            :items="itemsNotSave || items"
            :fields="fields"
            hide-filters
            sort-by="pacienteNome"
        >

            <template v-slot:cell(pacienteNome)="{ item }">
                {{ item.pacienteNome }}

                <template v-if="item.pacienteNomeSocial">
                    <template v-if="item.pacientePreferenciaNomeId === enums.preferenciaNome.NOME_SOCIAL">
                        <strong>({{ item.pacienteNomeSocial }})</strong>
                    </template>

                    <template v-else>
                        ({{ item.pacienteNomeSocial }})
                    </template>
                </template>
            </template>

            <template v-slot:cell(actions)="{ item }">

                <rkm-button
                        @click="handleDestroy(item)"
                        color="danger"
                        small
                        title="Cancelar resultado"
                    >
                        <rkm-icon icon="trash" />
                    </rkm-button>
            </template>
        </rkm-table>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { repository, error, object, formats, data, stringCase } from '@/mixins'

// Moment.
import moment from 'moment'

// Enums.
import statusAgendamento from '@/enums/exame-laboratorial/statusAgendamento'
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

export default {
    computed: {
        fields() {
            const fields = [
                {
                    key: "pacienteNome",
                    label: "Nome",
                    sortable: true
                },
                {
                    key: "dataNascimento",
                    label: "Data de nascimento",
                    sortable: true
                },
                {
                    key: "nomeMae",
                    label: "Nome da mãe",
                    sortable: true
                },
                {
                    key: "agendamentoNumero",
                    label: "Agendamento",
                    sortable: true
                },
                {
                    key: "data",
                    label: "Data do agendamento",
                    sortable: true
                },
                {
                    key: "exameGrupoNome",
                    label: "Exame",
                    sortable: true
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min'
                }
            ]

            return fields
        },
        validations() {

            return {
                periodo: {
                    start: { required: true },
                    end: { required: true },
                },
            }
        },
    },
    created() {

        this.repositories = {
            cancelamento: this.getConectaSusRepository('exameLaboratorial.cancelamentoResultado'),
            paciente: this.getConectaSusRepository('cadastro.sujeitoAtencao.paciente'),
            impressao: this.getConectaSusRepository('impressao.exameLaboratorial'),
        },

        this.load();
    },
    data() {
        return {
            model: {
                dataNascimento: null,
                prontuario: null,
                pacienteId: null,
                exameId: null,
                exames: null,
                grupos: null,
                agendamentoNumero: null,
                periodo: {
                    start: null,
                    end: null,
                },
            },
            agendamentoExame: [],
            itemsNotSave: null,
            saveAgendamento: {
                agendamentos: [],
            },
            paciente: null,
            localPaciente: {
                autocompleteFieldsPaciente: {
                    paciente: [
                        { key: 'cidadao.nome', searchable: true },
                    ],
                },
            },
            enums: {
                statusAgendamento,
                preferenciaNome
            },
            unwatchers: {
                modelPeriodoEnd: null,
                modelPeriodoStart: null,
            },
        }
    },
    mixins: [repository, error, object, formats, data, stringCase],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.model.periodo = this.data.form.periodo

            this.$nextTick()
                .then(() => this.loadFields())
                .then(() => this.addWatchers())
        },
        search() {

            this.setLoading()

            this.repositories.cancelamento.list(this.getSearchParams())
                .then(({ data }) => {

                    this.itemsNotSave = data.model.agendamentos
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getSearchParams() {

            const params = this.clone(this.model)

            if (this.paciente) {

                params.pacienteId = this.paciente.id
                params.pacienteNome = this.paciente.cidadao.nome
            }

            if (this.model.dataNascimento) {

                params.dataNascimento = moment(this.model.dataNascimento).format('YYYY-MM-DD')
            }

            this.formateDates(params.periodo, ['start', 'end'], 'YYYY-MM-DD')

            return this.camelObjectKeysToSnakeRecursive(params)
        },
        resetForm() {

            this.paciente = null
            this.model.dataNascimento = null
            this.model.agendamentoNumero = null
            this.model.prontuario = null
            this.model.exameId = null
            this.model.exames = null
            this.itemsNotSave = null

            this.setDefaultValues()

            this.$nextTick(() => this.$refs.Form.resetValidator())
        },
        setDefaultValues() {

            this.model.periodo.start = moment(this.data.form.dataAtual, 'DD/MM/YYYY').toDate()
            this.model.periodo.end = moment(this.data.form.dataAtual, 'DD/MM/YYYY').toDate()
        },
        setListagem() {

            this.itemsNotSave = null
        },
        loadFields() {

            this.setLoading()

            this.repositories.cancelamento.loadFields(this.getSearchParams())
                .then(({ data }) => {

                    this.loadExame(data.model.agendamentos)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        loadExame(agendamento) {

            const exameCadastrado = []

            agendamento.map(exame => {

                const exameInserido = exameCadastrado.find(u => u.id
                    === exame.exameGrupoId)

                if (!exameInserido) {

                    exameCadastrado.push({

                        id: exame.exameGrupoId,
                        nome: exame.exameGrupoNome,
                    })
                }
            })

            if (exameCadastrado) {

                exameCadastrado.sort((a,b) => (a.nome > b.nome) ? 1 : ((b.nome > a.nome) ? -1 : 0));
            }

            this.agendamentoExame = exameCadastrado
        },
        handleDestroy(item) {

            const destroy = () => this.repositories.cancelamento.destroy(item.agendamentoId, {
                agendamento_id: item.agendamentoId,
                exame_id: item.exameId,
            })
            .then(() => {

                const objId = this.itemsNotSave.findIndex((obj => obj.exameId == item.exameId));

                this.itemsNotSave.splice(objId, 1)
            })

            this.showDeleteConfirmation(`Deseja realmente cancelar o resultado do exame
                <strong>${item.exameGrupoNome}</strong> do agendamento
                <strong>${item.agendamentoNumero}</strong>?`, destroy, this.handleError)
        },
        addWatchers() {

            this.addModelPeridoStartWatcher()
            this.addModelPeridoEndWatcher()
        },
        addModelPeridoStartWatcher() {

            this.unwatchers.modelPeriodoStart = this.$watch('model.periodo.start', function () {

                this.setListagem()

                if (this.model.periodo.start && this.model.periodo.end) {

                    this.loadFields()
                }
            })
        },
        addModelPeridoEndWatcher() {

            this.unwatchers.modelPeriodoEnd = this.$watch('model.periodo.end', function () {

                this.setListagem()

                if (this.model.periodo.start && this.model.periodo.end) {

                    this.loadFields()
                }
            })
        },
    },
    props: {
        data: { type: Object, required: true }
    },
}
</script>

<style scoped>
.table-td {
    background: #f1f1f1;
    padding: 0 10px;
    height: 35px;
    border-top: 1px solid #ccc;
    font-weight: 600;
}
.table-border-top {
    border-top: 0;
    height: 30px;
    padding: 0;
}
.table-width {
    width: 100%;
}
</style>